/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FileFolderDto } from '../models/file-folder-dto';
import { SourceCodeResponseDto } from '../models/source-code-response-dto';

@Injectable({
  providedIn: 'root',
})
export class SourceCodeControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation sourceCodeControllerGetComponentDefinitionDirectoryEntries
   */
  static readonly SourceCodeControllerGetComponentDefinitionDirectoryEntriesPath = '/source-code/component-definition-dirents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getComponentDefinitionDirectoryEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComponentDefinitionDirectoryEntries$Response(params?: {
  }): Observable<StrictHttpResponse<FileFolderDto>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeControllerService.SourceCodeControllerGetComponentDefinitionDirectoryEntriesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileFolderDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getComponentDefinitionDirectoryEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComponentDefinitionDirectoryEntries(params?: {
  }): Observable<FileFolderDto> {

    return this.getComponentDefinitionDirectoryEntries$Response(params).pipe(
      map((r: StrictHttpResponse<FileFolderDto>) => r.body as FileFolderDto)
    );
  }

  /**
   * Path part for operation sourceCodeControllerGetComponentDefinitionFileContent
   */
  static readonly SourceCodeControllerGetComponentDefinitionFileContentPath = '/source-code/component-definition-file-content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getComponentDefinitionFileContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComponentDefinitionFileContent$Response(params?: {
    filePath?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeControllerService.SourceCodeControllerGetComponentDefinitionFileContentPath, 'get');
    if (params) {
      rb.query('filePath', params.filePath, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getComponentDefinitionFileContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getComponentDefinitionFileContent(params?: {
    filePath?: string;
  }): Observable<string> {

    return this.getComponentDefinitionFileContent$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation sourceCodeControllerGetDirectoryEntries
   */
  static readonly SourceCodeControllerGetDirectoryEntriesPath = '/source-code/dirents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDirectoryEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDirectoryEntries$Response(params?: {
  }): Observable<StrictHttpResponse<FileFolderDto>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeControllerService.SourceCodeControllerGetDirectoryEntriesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileFolderDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDirectoryEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDirectoryEntries(params?: {
  }): Observable<FileFolderDto> {

    return this.getDirectoryEntries$Response(params).pipe(
      map((r: StrictHttpResponse<FileFolderDto>) => r.body as FileFolderDto)
    );
  }

  /**
   * Path part for operation sourceCodeControllerGetFileContent
   */
  static readonly SourceCodeControllerGetFileContentPath = '/source-code/file-content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFileContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileContent$Response(params?: {
    filePath?: string;
  }): Observable<StrictHttpResponse<SourceCodeResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeControllerService.SourceCodeControllerGetFileContentPath, 'get');
    if (params) {
      rb.query('filePath', params.filePath, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SourceCodeResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFileContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFileContent(params?: {
    filePath?: string;
  }): Observable<SourceCodeResponseDto> {

    return this.getFileContent$Response(params).pipe(
      map((r: StrictHttpResponse<SourceCodeResponseDto>) => r.body as SourceCodeResponseDto)
    );
  }

}
